import React from 'react';
import Icon from '../Icon/Icon';
import { Notification } from '../../types/notification.types';
import { formatNotificationTime, notificationHref, notificationMeta } from '../../utils/notificationDisplay';
import './NotificationItem.scss';

type NotificationItemProps = {
  notification: Notification;
  compact?: boolean;
  onSelect: (notification: Notification) => void;
  onDelete: (id: number) => void;
};

const NotificationItem: React.FC<NotificationItemProps> = ({
  notification,
  compact = false,
  onSelect,
  onDelete
}) => {
  const meta = notificationMeta(notification.type);
  const href = notificationHref(notification);
  const unread = !notification.is_read;

  return (
    <article
      className={`nf-item${compact ? ' nf-item--compact' : ''}${unread ? ' is-unread' : ''}`}
    >
      <button
        type="button"
        className="nf-item__main"
        onClick={() => onSelect(notification)}
      >
        <span className={`nf-item__icon nf-item__icon--${meta.tone}`}>
          <Icon name={meta.icon} size={compact ? 13 : 14} />
        </span>
        <span className="nf-item__copy">
          <span className="nf-item__title">{notification.title}</span>
          <span className="nf-item__message">{notification.message}</span>
          <span className="nf-item__meta">
            <em>{formatNotificationTime(notification.created_at)}</em>
            <span>{meta.label}</span>
          </span>
        </span>
      </button>
      <div className="nf-item__side">
        {href ? <Icon name="chevron-right" size={12} className="nf-item__go" /> : null}
        <button
          type="button"
          className="nf-item__delete"
          onClick={e => {
            e.stopPropagation();
            onDelete(notification.id);
          }}
          aria-label="Supprimer"
        >
          <Icon name="x" size={12} />
        </button>
      </div>
    </article>
  );
};

export default NotificationItem;
